import { render, staticRenderFns } from "./CallReg.vue?vue&type=template&id=6c3d2f52&scoped=true"
import script from "./CallReg.vue?vue&type=script&lang=js"
export * from "./CallReg.vue?vue&type=script&lang=js"
import style0 from "./CallReg.vue?vue&type=style&index=0&id=6c3d2f52&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d2f52",
  null
  
)

export default component.exports